import React from "react";
import { Route, Routes } from "react-router-dom";
import { Header } from "./components";

import { useEagerConnect } from "./hooks/useEagerConnect";

import { Farms, Home, Liquidity } from "./pages";
import { Swap } from "./pages";

const App: React.FC = () => {
  useEagerConnect();
  return (
    <div>
      <Header />
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/farms" element={<Farms />} />
        <Route path="/swap" element={<Swap />} />
        <Route path="/Liquidity" element={<Liquidity />} />
        
      </Routes>
    </div>
  );
};

export default App;
